import React from "react";
import { Row, Col, Button } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { PacmanLoader } from "react-spinners";
import { FormattedMessage, IntlContext } from "react-intl";
import ConfirmDialog from "../../components/Modal/ConfirmDialog";

class ProgramLicenseCourseComponent extends React.Component {
  static contextType = IntlContext;
  constructor(props) {
    super(props);
    this.state = {
      dialogVisible: false,
      course: null,
    };
    this.onRemoveCourseClick = this.onRemoveCourseClick.bind(this);
    this.onOk = this.onOk.bind(this);
    this.onCancel = this.onCancel.bind(this);
  }

  onRemoveCourseClick(course) {
    this.course = course;
    this.setState({ dialogVisible: true });
  }

  onOk() {
    this.setState({ dialogVisible: false });

    this.props.disconnect(this.props.program.licenseName, this.course.id);
  }

  onCancel() {
    this.setState({ dialogVisible: false });
  }

  render() {
    const intl = this.context;
    let mappedCourses = this.props.courses.map((course, i) => (
      <div className="list-group-item" key={course.id} index={i}>
        <Row className="m-0 p-0">
          <Col lg="8">{course.name}</Col>
          <Col lg="4">
            {this.props.removingCourseFromLicense.some(
              (item) =>
                item.licenseName === this.props.program.licenseName &&
                item.courseId === course.id
            ) ? (
              <PacmanLoader color={"#20a8d8"} loading={true} size={10} />
            ) : (
              <Button
                outline
                color="primary"
                size="sm"
                title={intl.formatMessage({ id: "DisconnectCourseFromProgramLicense" })}
                className="float-end"
                onClick={() => this.onRemoveCourseClick(course)}
              >
                <FontAwesomeIcon icon="unlink" />
              </Button>
            )}
          </Col>
        </Row>

        <ConfirmDialog
          isOpen={this.state.dialogVisible}
          title={<FormattedMessage id="Confirm" />}
          toggle={this.onCancel}
          onProceed={() => {
            this.onOk();
          }}
          message={
            <FormattedMessage
              id="ConfirmDisconnectCourseFromProgram"
              values={{
                courseName: this.course
                  ? this.course.name
                  : intl.formatMessage({ id: "Course" }),
                programName: this.props.program
                  ? this.props.program.licenseName
                  : intl.formatMessage({ id: "Program" }),
              }}
            />
          }
          danger={true}
        />
      </div>
    ));

    return <ul className="list-group">{mappedCourses}</ul>;
  }
}

export default ProgramLicenseCourseComponent;
